import { createStore, createTypedHooks } from "easy-peasy";
import storeModel, { IStoreModel } from "./easy-peasy/storeModel";

const { useStoreActions, useStore, useStoreState } = createTypedHooks<IStoreModel>();

export { useStoreActions, useStoreState, useStore };

const store = createStore(storeModel);

export default store;